import { BooleanBase } from '../BooleanBase';

export class RunOfNetwork extends BooleanBase {}
